import {
  EmployeesListRequestParams,
  EmployeesListResult,
} from 'app/common/types/employees/employees-list'

import { EmployeeId } from 'app/common/types/id'
import { Name } from 'app/common/classes/name'

import type { Request } from '../../index'

type ParamsDto = {
  school_id: number
  customer_type: string
}

const legacyMapping = new Map([
  ['guest', 'Гость'],
  ['employee', 'Сотрудники'],
  ['student', 'Учащиеся'],
])

type PathParamsDto = null

export const convertParams = (params: EmployeesListRequestParams): [ParamsDto, PathParamsDto] => {
  return [
    {
      school_id: parseInt(params.orgId, 10),
      customer_type: legacyMapping.get(params.customerType) || params.customerType,
    },
    null,
  ]
}

type ResultDto = Record<
  string,
  { id: number; name: { first: string; last: string; middle: string } }
>

export const convertResult = (result: ResultDto): EmployeesListResult => {
  return Object.values(result).map((item) => {
    return {
      id: String(item.id) as EmployeeId,
      name: new Name(item.name),
    }
  })
}

export const GET_EMPLOYEES_LIST: Request<EmployeesListRequestParams, EmployeesListResult, void> = [
  'reports/employees_list',
  'get',
  ['data', 'employees'],
]
